import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Experiments } from "../../../domain/repositories/ABTestClient";
import { experimentNameShortener } from "./experimentNameShortener";
import { EmptyStateTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackEmptyStateFunctionArgs {
  readonly type: "UnlockYourCYL" | "UpdateYourProfile";
  readonly experiments: Experiments | undefined;
}

interface TrackEmptyStateFunction {
  (args: TrackEmptyStateFunctionArgs): void;
}

interface UseTrackEmptyStateFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackEmptyStateFunction {
  (agrs: UseTrackEmptyStateFunctionArgs): TrackEmptyStateFunction;
}

const useTrackEmptyState: UseTrackEmptyStateFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<EmptyStateTrackingEvent>();

  const trackEmptyState: TrackEmptyStateFunction = useCallback(
    ({ type, experiments }) => {
      emitUserEvent({
        event: TrackingEventName.EMPTY_STATE,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        type,
        experiments: experiments ? JSON.stringify(experimentNameShortener(experiments)) : undefined,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackEmptyState;
};

export { useTrackEmptyState };
